
import Vue from 'vue';
import { calcRdBalanceToRunnitTokens } from '@run-diffusion/shared';
import TokensSVG from '@/assets/TokensSVG.vue';

export default Vue.extend({
	name: 'HardwareOfferPriceInTokens',
	props: {
		value: {
			type: Number,
			required: true,
		},
		showPrefix: {
			type: Boolean,
			default: true,
		},
		iconSize: {
			type: Number,
			default: 12,
		},
	},
	computed: {
		tokensPerHour (): number {
			return calcRdBalanceToRunnitTokens(this.value, true);
		},
	},
	components: {
		TokensSVG,
	},
});
